<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="600px"
              scrollable
			  z-index="210"
    >
        <v-card>
			<create-company-dialog @created="fillCompany" ref="createCompanyDialog"></create-company-dialog>
            <v-toolbar dense :elevation="0">
                <v-toolbar-title  class="text-primary-700">
                    Create Contact
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width:35px; height:35px;" icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
			<v-divider></v-divider>
            <v-card-text class="py-4">
                <form>
					<v-row>
						<v-col cols="12">
							<v-text-field
									outlined
									dense
									hide-details
									v-model="form.name"
									v-validate="'required|min:3'"
									:error-messages="errors.collect('form.name')"
									label="Name"
									data-vv-name="form.name"
									data-vv-as="Name"
									required
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field
									outlined
									dense
									hide-details
									label="E-mail"
									name="profile_email"
									v-validate="'required|email'"
									v-model="form.email"
									:error-messages="errors.collect('form.email')"
									data-vv-name="form.email"
									data-vv-as="E-mail"
									required
									autocomplete="off"
									@change="findCompanyByDomain"
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-autocomplete
								outlined
								dense
								hide-details
								v-model="form.selectedCompany"
								:search-input.sync="companies.search"
								:items="companies.items"
								label="Company"
								:item-text="'name'"
								:loading="companies.loading"
								clearable
								return-object
								hide-no-data
								data-vv-name="form.selectedCompany"
								data-vv-as="Company"
								:error-messages="errors.collect('form.selectedCompany')"
								ref="companiesCombobox"
							>
								<template v-slot:append>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon @click="form.selectedCompany = null; $refs.createCompanyDialog.showDialog();" v-on="on">mdi-plus</v-icon>
										</template>
										<span>Create a new company</span>
									</v-tooltip>
								</template>
									
							</v-autocomplete>
							<div v-if="checkCompanySearch" style="margin-top: -22px; position: relative;">No companies found. <a @click="form.selectedCompany = null; $refs.createCompanyDialog.showDialog();">Create a new company</a></div>
						</v-col>
						<v-col cols="6">
							<v-text-field
								outlined
								dense
								hide-details
								label="Direct Dial"
								v-validate="''"
								v-model="form.direct_dial"
								:error-messages="errors.collect('form.direct_dial')"
								data-vv-name="form.direct_dial"
								data-vv-as="Direct Dial"
						></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field
								outlined
								dense
								hide-details
								label="Mobile"
								v-validate="''"
								v-model="form.mobile"
								:error-messages="errors.collect('form.mobile')"
								data-vv-name="form.mobile"
								data-vv-as="Mobile"
							></v-text-field>
						</v-col>
					</v-row>
                </form>
            </v-card-text>
			<v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined @click="closeDialog">Cancel</v-btn>
                <v-btn elevation="0" :disabled=" !formValidated" color="primary" @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
 	import CreateCompanyDialog from '@/components/companies/createCompanyDialog'
	export default {
		name: "createUserDialog",
		props: ['company'],
		components: {
            CreateCompanyDialog,
		},
		data: () => ({
			dialog: false,
			form: {
				name: '',
				email: '',
				selectedCompany: null,
				direct_dial: '',
				mobile: ''
			},
			companies: {
				loading: false,
				items: [],
				search: null,
			},
		}),
		watch: {
			'companies.search'() {
				this.getCompanies();
			},
		},
		computed: {
			formValidated() {
				return Object.keys(this.fields).some(key => this.fields[key].validated)
					&& Object.keys(this.fields).some(key => this.fields[key].valid);
			},
			checkCompanySearch(){
                // return (this.Companies.length == 0 & !this.companiesLoading & (this.search.company && this.search.company.length > 0)) & !this.formErrors.companyContact & (!this.form.selectedCompany || typeof this.form.selectedCompany == 'string')
				return (this.companies.items.length == 0 & !this.companies.loading & (this.companies.search && this.companies.search.length > 0))
            },
		},
		methods: {
			showDialog: function () {
				this.dialog = true;
				if(this.company) {
					this.form.selectedCompany = this.company;
					this.companies.items.push(this.company)
                }
			},
			closeDialog: function () {
				this.dialog = false;
				this.clearForm();
				this.$emit('closed');
			},
			async save() {

				if (await this.$formValidator.validate(this.form)) {
					try {
						const response = await this.$http.post('/users', {
							company_id: this.form.selectedCompany ? this.form.selectedCompany.id : null,
							name: this.form.name,
							email: this.form.email,
							direct_dial: this.form.direct_dial,
							mobile: this.form.mobile,
						})
						this.$emit('created', response.data.data);
						this.closeDialog();
					} catch (e) {
						this.$validationException(e)
					}
				}
			},
			clearForm () {
				this.form = {
					name: '',
					email: '',
					selectedCompany: null,
					direct_dial: '',
					mobile: ''
				};
				this.$validator.reset();
			},
			async getCompanies() {
				this.$http.get("/companies",{
					params: {
						q:	this.companies.search,
						per_page: 50,
					}
				}).then(response => {
					if(response.data.data.length == 0) {
						this.companies.items = [];
					}else{
						this.companies.items = response.data.data
					}
					
					this.companies.loading = false;
				}).catch(error => {
					this.companies.loading = false;
				})
			},
			async findCompanyByDomain() {
				console.log('findCompanyByDomain', this.form.email);
				console.log('this.company', this.company);
				if(this.form.selectedCompany) return;
				console.log('pass')
				const response = await this.$http.get('/companies/by-domain', {
					params: {
						domain: this.form.email.split('@')[1]
					}
				});
				if(Object.keys(response.data).length) {
					this.form.selectedCompany = response.data;
					this.companies.items.push(response.data);
				} else {
					// this.form.selectedCompany = null;
				}
			},

			fillCompany(company){
				this.companies.items.push(company);
                this.form.selectedCompany = company;
            },
		},

	}
</script>

<style scoped>

</style>